<template>
  <section
    class="rounded-[24px] lg:rounded-[40px] bg-white p-6 lg:p-8 shadow-widget"
  >
    <div class="mx-auto grid justify-items-center gap-4 text-center">
      <div class="relative h-10 w-10 shrink-0 lg:h-12 lg:w-12">
        <span class="absolute inset-0 rounded-full border-4 border-brand/15" />
        <span
          class="absolute inset-0 animate-spin rounded-full border-4 border-transparent border-t-brand"
        />
      </div>
      <p class="text-base lg:text-xl font-semibold leading-5 lg:leading-6">
        Загружаем тарифы
      </p>
    </div>
  </section>
</template>
